import { ArrowDownwardIcon } from '@medly-components/icons';
import { StickyButtonWrapper } from 'components/common/StickyButtonWrapper/StickyButtonWrapper.styled';
import { rgba } from 'polished';
import styled from 'styled-components';

export const CaptureInfoFormActionsStyled = styled(StickyButtonWrapper)<{ showShadow: boolean }>`
    box-sizing: border-box;
    padding: 2rem 4.8rem;
    position: sticky;
    bottom: 0;
    box-shadow: ${({ theme, showShadow }) => showShadow && `0 -1.8rem 1.6rem -1.6rem ${rgba(theme.colors.grey[400], 0.6)}`};
    background-color: ${({ theme }) => theme.colors.white};

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -4.8rem;
        border-top: 1px solid ${({ theme }) => theme.colors.grey[200]};
        width: calc(100% + 9.6rem);
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        padding: 1.6rem 2.4rem;
        width: 100%;
        margin-left: 0;
        margin-top: auto;
        position: fixed;
        bottom: 0;
    }
`;

export const DownArrow = styled(ArrowDownwardIcon)`
    border: 1px solid ${({ theme }) => theme.colors.grey[300]};
    border-radius: 50%;
    padding: 5px;
    position: absolute;
    top: -50px;
    left: 50%;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 0 1.5rem ${({ theme }) => rgba(theme.colors.grey[500], 0.8)};

    & > * {
        fill: ${({ theme }) => theme.colors.darkBlue};
    }
`;
